const style = {
    navBorder: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        zIndex: 1,
        width: '100%',
    },
}

export default style;